import { TweenMax, Power1, Power4 } from 'gsap'
import ScrollToPlugin from 'gsap/ScrollToPlugin' // eslint-disable-line

export const fadeIn = (el, dur = 0.5, cb) => {
	const onComplete = typeof cb !== undefined ? cb : null
	TweenMax.to(el, dur, {autoAlpha: 1, ease: Power1.easeOut, onComplete: onComplete})
}

export const fadeOut = (el, dur = 0.5, cb) => {
	const onComplete = typeof cb !== undefined ? cb : null
	TweenMax.to(el, dur, {autoAlpha: 0, ease: Power1.easeOut, onComplete: onComplete})
}

export const fadeInStaggered = (els, dur = 0.5, interval = 0.08, cb) => {
	const onCompleteAll = typeof cb !== undefined ? cb : null
	TweenMax.staggerTo(els, dur, {autoAlpha: 1, ease: Power1.easeOut}, interval, onCompleteAll)
}

export const fadeOutStaggered = (els, dur = 0.5, interval = 0.08, cb) => {
	const onCompleteAll = typeof cb !== undefined ? cb : null
	TweenMax.staggerTo(els, dur, {autoAlpha: 0, ease: Power1.easeOut}, interval, onCompleteAll)
}

export const rotateIn = (el, dur = 0.8, cb) => {
	const onComplete = typeof cb !== undefined ? cb : null
	TweenMax.to(el, dur, {rotationY:0, autoAlpha: 1, ease:Power1.easeOut, onComplete: onComplete})
}

export const scrollToTop = (dur = 1) => {
	typeof window !== 'undefined' && TweenMax.to(window, dur, {scrollTo:0, ease:Power4.easeOut})
}


// WEBPACK FOOTER //
// /opt/build/repo/src/animations.js